<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
    <div class="auth-box">
      <div id="notifyform">
        <div class="logo">
          <span class="db">
            <img alt="logo" src="../../assets/images/logo/logo-icon-lg.png" style="width:40px; height:auto;">
            <img alt="logo" src="../../assets/images/logo/logo-text-lg.png" style="width:100px; height:auto;">
          </span>
          <h4 class="font-medium m-t-40 m-b-20">
            Change Your Password
          </h4>
        </div>
        <!-- Form -->
        <div v-if="token === undefined" class="row">
          <div class="col-12">
            <form id="changePasswordForm" class="form-horizontal m-t-20" data-vv-scope="changePasswordForm" @submit.prevent="handleSubmit('changePasswordForm')">
              <!--                            <div class="input-group mb-3">-->
              <!--                                <div class="input-group-prepend">-->
              <!--                                    <span class="input-group-text" id="basic-addon1"><i class="ti-user"></i></span>-->
              <!--                                </div>-->
              <!--                                <input aria-describedby="basic-addon1" aria-label="Email" class="form-control form-control-lg" placeholder="Email" type="text"-->
              <!--                                       v-model="credentials.email" v-validate="'required|email'">-->
              <!--                            </div>-->
              <!--                            <div class="input-group mb-3">-->
              <!--                                <div class="input-group-prepend">-->
              <!--                                    <span class="input-group-text" id="basic-addon2"><i class="ti-pencil"></i></span>-->
              <!--                                </div>-->
              <!--                                <input aria-describedby="basic-addon2" aria-label="Old Password" class="form-control form-control-lg" placeholder="Old Password" type="password"-->
              <!--                                       v-model="credentials.oldPass" v-validate="'required'">-->
              <!--                            </div>-->
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon3" class="input-group-text"><i class="ti-pencil" /></span>
                </div>
                <input v-model="credentials.newPass" aria-describedby="basic-addon3" aria-label="New Password" class="form-control form-control-lg" placeholder="New Password" type="password">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon4" class="input-group-text"><i class="ti-pencil" /></span>
                </div>
                <input v-model="credentials.confPass" aria-describedby="basic-addon3" aria-label="Confirm Password" class="form-control form-control-lg" placeholder="Confirm Password" type="password">
              </div>
              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-dribbble" type="submit">
                    Change Password
                  </button>
                </div>
              </div>
              <div class="form-group m-b-0 m-t-10">
                <div class="col-sm-12 text-center">
                  Return to Dashboard?
                  <router-link :to="{ name: 'dashboard'}" class="text-info m-l-5">
                    <b>Click Here !</b>
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <form id="resetPasswordForm" class="form-horizontal m-t-20" data-vv-scope="resetPasswordForm" @submit.prevent="handleSubmit('resetPasswordForm')">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon5" class="input-group-text"><i class="ti-pencil" /></span>
                </div>
                <input v-model="resetCredential.password" v-validate="'required'" aria-describedby="basic-addon2" aria-label="Password" class="form-control form-control-lg" placeholder="New Password" type="password">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon6" class="input-group-text"><i class="ti-pencil" /></span>
                </div>
                <input v-model="resetCredential.confirmPassword" v-validate="'required'" aria-describedby="basic-addon3" aria-label="confirm Password" class="form-control form-control-lg" placeholder="Confirm Password" type="password">
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-dribbble" type="submit">
                    Change Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChangePassword',
  props: ['token'],
  data () {
    return {
      loading: false,
      credentials: {
        email: '',
        oldPass: '',
        newPass: '',
        confPass: ''
      },
      resetCredential: {
        password: '',
        confirmPassword: ''
      },
      loggingIn: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      $('[data-toggle="tooltip"]').tooltip()
      $('.preloader').fadeOut()

      $('#to-recover').on('click', function () {
        $('#notifyform').slideUp()
        $('#recoverform').fadeIn()
      })
    },
    handleSubmit (context) {
      this.$validator.validateAll(context)
        .then(reply => {
          if (!reply) {
            this.$toastr.e('All fields are required', 'Error')
          } else {
            if (context === 'changePasswordForm') {
              this.changePassword()
            } else if (context === 'resetPasswordForm') {
              this.resetPassword()
            }
          }
        })
    },
    async changePassword () {
      if (this.credentials.newPass === this.credentials.confPass) {
        delete this.credentials.confPass
        try {
          await this.$accounts.patch('/accounts/user', {
            password: this.credentials.newPass
          })
          await this.$swal('Success', 'Password changed successfully. Please Re-Login.', 'info')
          this.$store.commit('LOGOUT')
          await this.$router.replace('/auth/login')
        } catch (err) {
          console.log(err)
          this.$toastr.e('Invalid credentials', 'Error')
        }
      } else {
        this.$toastr.e('Password and Confirm Password Mismatch', 'Error')
      }
    },
    async resetPassword () {
      if (this.resetCredential.password === this.resetCredential.confirmPassword) {
        try {
          await this.$accounts.post(`/changePassword/${this.token}`, { newPass: this.resetCredential.password })
          this.$swal('Success', 'Password changed successfully. Please Re-Login.', 'info')
          this.$store.commit('LOGOUT')
          this.$router.replace('/auth/login')
        } catch (err) {
          console.log(err)
        }
      } else {
        this.$toastr.e('Password and Confirm Password Mismatch', 'Error')
      }
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  background: linear-gradient(
      0deg,
      rgba(54, 64, 78, 0.75),
      rgba(54, 64, 78, 0.75)
    ),
    url(../../assets/images/big/harvest.jpg);
  background-size: cover;
}
</style>
